var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_88)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.834 43.0468C17.9941 42.0312 18.6078 26.3801 17.3804 25.3906C15.1391 24.4531 11.7237 25.5989 9.10881 24.7395C5.66675 15.1041 15.2458 4.50515 24.985 4.47911C35.2312 4.45306 43.1025 13.9583 40.9412 24.7916C35.8449 25.9635 32.5629 23.2031 31.9759 27.0312L32.216 42.9947C35.3912 43.5156 39.3937 42.552 41.4215 43.9062C40.7011 45.9114 40.034 45.4166 37.3924 45.4166C35.4179 45.4166 33.4167 45.3906 31.4422 45.3906C30.4016 45.3906 26.3992 45.2083 25.7054 45.5989C24.3713 46.3281 23.7843 49.0885 26.2124 49.8697C26.6927 50.026 37.1523 49.9999 38.3797 49.9479C42.5956 49.7395 44.8102 48.1249 45.6641 45.1301C46.4379 42.3697 45.9309 25.9374 45.9309 21.7968C45.8242 -2.16152 16.9002 -7.23964 6.33381 10.9114C3.05184 16.5624 4.11915 25.5989 4.09247 32.7864C4.09247 42.4218 7.45448 44.1666 17.834 43.0468Z",
    fill: "#8B0E01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupport);
export default __webpack_public_path__ + "static/media/OnlineSupport.82a5f215455c5f002f5328e54ef4a127.svg";
export { ForwardRef as ReactComponent };